export function CompanySettingsPage () {
  return (
    <div className='p-6'>
      <h2 className='heading-md'>Company</h2>
    </div>
  )
}
